<template>
  <main class="container mb-4 d-block d-lg-none">
    <h5 class="my-5" v-if="resultados.length > 0">Resultados:</h5>
    <div class="listado mov" id="verLista" v-if="resultados.length > 0">
      <div
        v-for="(carrera, index) in resultadosPaginados"
        :key="index"
        class="mb-4"
      >
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" class="word-break">Región / Sede</th>
              <th scope="col">Institución</th>
              <th scope="col">Carrera</th>
              <!--<th scope="col">Gratuidad</th>-->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="font-weight-bold">{{ carrera.region }}</span>
                <br />
                {{ carrera.sede }}
              </td>
              <td class="font-weight-bold word-break">
                {{ carrera.institucion }}
              </td>
              <td class="text-left">
                <div
                  @click="
                    irAFicha(carrera.codigoInstitucion, carrera.codigoCarrera)
                  "
                >
                  {{ carrera.carrera }}
                </div>
              </td>
              <!--<td>
                <Gratuidad :gratuidad="carrera.gratuidad" styleImg="max-width: 24px;" />
              </td>-->
            </tr>
          </tbody>
        </table>

        <table class="table table-sm">
          <thead>
            <tr>
              <th colspan="2" scope="col" class="bg-gris-medio">
                Puntaje Simulado
              </th>
            </tr>
            <tr>
              <th scope="col" class="bg-gris-medio">
                <span>Escala Nueva (100-1000)</span>
              </th>
              <th scope="col" class="bg-gris-medio">
                <span>Escala Antigua (150-850)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-azul">
                <div
                  v-if="carrera.puntajeSimulado === '*'"
                  v-b-tooltip.hover.top="
                    'Exige Prueba Electiva que figura sin puntaje en la Simulación.'
                  "
                >
                  <img
                    src="@/assets/img/asterisk-solid.svg"
                    style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
                    class="mr-2"
                  />
                </div>
                <div v-else>{{ carrera.puntajeSimulado }}</div>
              </td>
              <td class="text-azul">
                <div
                  v-if="carrera.puntajeSimuladoPDT === '*'"
                  v-b-tooltip.hover.top="
                    'Exige Prueba Electiva que figura sin puntaje en la Simulación.'
                  "
                >
                  <img
                    src="@/assets/img/asterisk-solid.svg"
                    style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
                    class="mr-2"
                  />
                </div>
                <div v-else>{{ carrera.puntajeSimuladoPDT }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-sm">
          <thead>
            <tr>
              <th colspan="3" scope="col" class="bg-gris-medio">
                Último Seleccionado
              </th>
            </tr>
            <tr>
              <th scope="col" class="bg-gris-medio">
                <span>Admisión 2022 - Escala Antigua (150 - 850)</span>
              </th>
              <th scope="col" class="bg-gris-medio">
                <span>Admisión 2021 - Escala Antigua (150 - 850)</span>
              </th>
              <th scope="col" class="bg-gris-medio">
                <span>Admisión 2020 - Escala Antigua (150 - 850)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-azul">
                <div
                  v-if="
                    !carrera.ultimoSeleccionadoA1 ||
                      carrera.ultimoSeleccionadoA1 === '0'
                  "
                  style="font-size: 1.5rem; margin: 0.1rem"
                >
                  -
                </div>
                <div v-else>{{ carrera.ultimoSeleccionadoA1 }}</div>
              </td>
              <td class="text-azul">
                <div
                  v-if="
                    !carrera.ultimoSeleccionadoA2 ||
                      carrera.ultimoSeleccionadoA2 === '0'
                  "
                  style="font-size: 1.5rem; margin: 0.1rem"
                >
                  -
                </div>
                <div v-else>{{ carrera.ultimoSeleccionadoA2 }}</div>
              </td>
              <td class="text-azul">
                <div
                  v-if="
                    !carrera.ultimoSeleccionadoA3 ||
                      carrera.ultimoSeleccionadoA3 === '0'
                  "
                  style="font-size: 1.5rem; margin: 0.1rem"
                >
                  -
                </div>
                <div v-else>{{ carrera.ultimoSeleccionadoA3 }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-md-12 d-block pl-1 py-2 mr-auto">
        <p
          v-if="mostrarTextoAdmisionactual || mostrarTextoAdmisionAnterior"
          class="mb-0"
        >
          <small>
            (
            <span style="font-size: 1.5rem; margin: 0.1rem">-</span> ) Carreras
            sin postulación centralizada en procesos anteriores.
          </small>
        </p>
        <p v-if="mostrarTextoPruebaElectiva" class="mb-0">
          <small>
            (
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: 0.5rem; margin: 0.2rem 0.2rem 0.2rem 0.2rem"
              class="mr-2"
            />) Exige Prueba Electiva que figura sin puntaje en la Simulación.
          </small>
        </p>
        <p class="mb-0">
          <small
            >En el cálculo de esta simulación no están incluidas las
            ponderaciones de la/las Prueba/s de acceso especiales declaradas por
            las instituciones para el proceso de admisión 2021.
            <a :href="pdfSimulador" target="_blank">Conoce aquí</a> más
            detalles.</small
          >
        </p>
      </div>
      <b-pagination
        v-show="resultados.length > 0"
        v-model="paginaActual"
        :total-rows="resultados.length"
        :per-page="perPage"
        limit="5"
        class="col-md-4 mx-auto px-0"
        align="center"
      ></b-pagination>
      <!--<div class="col-6 col-lg-4 input-lg align-self-center px-0 mb-5">
        <button
          @click="solicitarSimulacion"
          class="btn btn-blue w-100 rounded-0"
          type="button"
          id="inputGroupFileAddon2"
        >
          ENVIAR SIMULACIÓN
        </button>
      </div>-->
    </div>
  </main>
</template>

<script>
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import { ModalSolicitarSimulacion } from "@/utils/BusesDeEventos.js";
export default {
  name: "ResultadosMovil",
  props: {
    resultados: { type: Array }
  },
  data() {
    return {
      resultadosPaginados: [],
      paginaActual: 1,
      perPage: 8,
      pdfSimulador: CDN.PDF_SIMULADOR
    };
  },
  components: {
    Gratuidad
  },
  watch: {
    paginaActual() {
      this.paginaInstituciones(this.resultados, this.paginaActual);
    },
    resultados() {
      this.paginaInstituciones(this.resultados, this.paginaActual);
    }
  },
  computed: {
    mostrarTextoPruebaElectiva() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        let respuesta = listado.some(res => res.puntajeSimulado === "*");
        return respuesta;
      } else {
        return false;
      }
    },
    mostrarTextoAdmisionactual() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        if (listado.includes(res => !res.admisionActual)) {
          return true;
        }
        if (listado.includes(res => res.admisionActual === "0")) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    mostrarTextoAdmisionAnterior() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        if (listado.some(resu => !resu.admisionAnterior)) {
          return true;
        }
        if (listado.some(resu => resu.admisionAnterior === "0")) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
  },
  methods: {
    solicitarSimulacion() {
      this.$ga.event({
        eventCategory: "Sistema-Acceso",
        eventAction: "simulador-ponderaciones",
        eventLabel: "abrir-modal-envio-simulacion-movil"
      });
      ModalSolicitarSimulacion.$emit("solicitarSimulacion");
    },
    irAFicha(codigoInstitucion, codigoCarrera) {
      this.$router.push({
        name: "FichaCarreraU",
        params: {
          idInstitucion: codigoInstitucion,
          codigoCarrera: codigoCarrera,
          origen: "SimuladorPonderaciones"
        }
      });
    },
    paginaInstituciones(instituciones, pagina) {
      let arreglo = [];
      if (instituciones.length > 0) {
        let inicio = (pagina - 1) * this.perPage;
        let final =
          pagina * this.perPage > instituciones.length
            ? instituciones.length
            : pagina * this.perPage;
        arreglo = instituciones.slice(inicio, final);
      }
      this.resultadosPaginados = arreglo;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/simuladorPonderaciones/ResultadosMovil.vue